import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import throttle from 'lodash.throttle';
import './AppointmentFlowWizard.scss';
import AppointmentInfo from 'components/molecules/AppointmentInfo/';
import ContentFooter from 'components/pages/components/ContentFooter';
import qs from 'store/entities/QueryString';
import { SCI_FOOTER_KEYS, ST_FOOTER_KEYS } from 'constants/localizationKeys';

const ns = 'appointment-flow-wizard';

class AppointmentFlowWizard extends Component {
  constructor(props) {
    super(props);
    this.throttleHandleScroll = throttle(this.handleScroll, 250);
    this.state = {
      prevScrollpos: window.pageYOffset,
      visible: true
    };
  }

  // Adds an event listener when the component is mount.
  componentDidMount() {
    window.addEventListener('scroll', this.throttleHandleScroll);
  }

  // Remove the event listener when the component is unmount.
  componentWillUnmount() {
    window.removeEventListener('scroll', this.throttleHandleScroll);
  }

  // Hide or show the menu.
  handleScroll = () => {
    const { prevScrollpos } = this.state;

    const currentScrollPos = window.pageYOffset;
    const visible = prevScrollpos > currentScrollPos;
    this.setState({
      prevScrollpos: currentScrollPos,
      visible
    });
  };

  render() {
    const {
      className,
      header,
      footer,
      body,
      isSelfCheckIn,
      isStatusTracker,
      showHeader,
      ctaBanner,
      hideFooter,
      showSCIProgressBar
    } = this.props;
    const { visible } = this.state;
    const modalView = qs.get('vmode') === 'modal';
    const classProps = cn(ns, className, {
      [`${ns}--self-check-in`]: isSelfCheckIn,
      [`${ns}__inside-frame`]: showHeader,
      [`${ns}--c8-on-modal`]: modalView,
      [`${ns}--cta`]: ctaBanner,
      [`${ns}--show-sci-progress-bar`]: isSelfCheckIn && showSCIProgressBar,
      [`${ns}--hide-header`]: !visible && showSCIProgressBar
    });
    let locKeys = false;
    if (isSelfCheckIn) {
      locKeys = SCI_FOOTER_KEYS;
    }
    if (isStatusTracker) {
      locKeys = ST_FOOTER_KEYS;
    }
    return (
      <div className={classProps}>
        <header>
          <div className={`${ns}__header`}>
            <AppointmentInfo key="appointmentInfo" />
            {header() && (
              <div className={`${ns}__header-wrap`}>
                <div className={`${ns}__header-content`}>{header()}</div>
              </div>
            )}
          </div>
        </header>
        <main>
          <div className={`${ns}__body`}>{body()}</div>
        </main>
        <footer>
          {!hideFooter && (
            <div className={`${ns}__footer`}>
              <div className={`${ns}__footer-wrap`}>
                <div className={`${ns}__footer-content`}>{footer()}</div>
              </div>
            </div>
          )}
          <ContentFooter
            className={hideFooter ? '' : 'middle-footer'}
            localizationKeys={locKeys}
          />
        </footer>
      </div>
    );
  }
}

AppointmentFlowWizard.propTypes = {
  body: PropTypes.func.isRequired,
  className: PropTypes.string,
  footer: PropTypes.func.isRequired,
  header: PropTypes.func.isRequired,
  isSelfCheckIn: PropTypes.bool,
  showHeader: PropTypes.bool.isRequired,
  ctaBanner: PropTypes.object,
  isStatusTracker: PropTypes.bool,
  hideFooter: PropTypes.bool,
  showSCIProgressBar: PropTypes.bool
};

export default AppointmentFlowWizard;



// WEBPACK FOOTER //
// ./src/components/templates/AppointmentFlowWizard/AppointmentFlowWizard.js